import Vue from 'vue'
import Vuex from 'vuex'
import * as api from '@/api/index.js'
import jstools from '@/utils/tools-web.js'
import { Message } from 'element-ui';

Vue.use(Vuex)

const pdfjsLib = require('pdfjs-dist');
pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

let fileNamesLoading = []

export default new Vuex.Store({
  state: {
    userInfo: {},
    goodsId: '',
    bookId: '',
    bookInfo: {},
    bookDubInfo: {},
    roleDubInfo: [],
    roleIdActive: '',
    roleFileKeyActive: '',
    roleEvaResultActive: null,
    dubFile: null,
    dubParams: null,
    dubType: 'all',
    myWorks: [],
    likeWorkIds: [],
    highLikeWorks: [],
    questions: [],
    questionReplaceDict: {},
    answersList: [],
    fileUrlDict: {}, // 当前资源信息字典
    pageSizeInfo: {width: 0, height: 0, ratio: 1},
    pdfDocDict: {}, // PDF文档字典，存储已加载的PDF文档对象，key为pdfKey
    pdfUrlLoading: [] // 正在加载的PDF URL列表（pdfKey）
  },
  getters: {
    workIdDict(state) {
      let result = {}
      let works = [...state.myWorks, ...state.highLikeWorks]
      works.forEach(v => {
        result[v.id] = v
      })
      return result
    }
  },
  mutations: {
    userInfoSetter (state, params) {
      state.userInfo = params
    },
    bookIdSetter (state, params) {
      state.bookId = params
      localStorage.setItem('bookId', params)
    },
    goodsIdSetter (state, params) {
      state.goodsId = params
      localStorage.setItem('goodsId', params)
    },
    bookInfoSetter (state, params) {
      state.bookInfo = params || {}
    },
    bookDubInfoSetter (state, params) {
      state.bookDubInfo = params || {}
    },
    roleDubInfoSetter (state, params) {
      state.roleDubInfo = params || []
    },
    likeWorkIdsSetter (state, params) {
      state.likeWorkIds = params || []
    },
    roleIdActiveSetter (state, params) {
      state.roleIdActive = params
    },
    roleFileKeyActiveSetter (state, params) {
      state.roleFileKeyActive = params || ''
    },
    roleEvaResultActiveSetter (state, params) {
      state.roleEvaResultActive = params || null
    },
    dubFileSetter (state, params) {
      state.dubFile = params || null
    },
    dubParamsSetter (state, params) {
      state.dubParams = params || null
    },
    dubTypeSetter (state, params) {
      state.dubType = params || ''
    },
    myWorksSetter (state, params) {
      state.myWorks = params || []
    },
    highLikeWorksSetter (state, params) {
      state.highLikeWorks = params || []
    },
    questionsSetter (state, params) {
      state.questions = params || []
    },
    questionReplaceDictSetter (state, params) {
      state.questionReplaceDict = params || {}
    },
    answersListSetter (state, params) {
      state.answersList = params || []
    },
    fileUrlDictSetter (state, params) {
      state.fileUrlDict = {
        ...(state.fileUrlDict || {}),
        ...(params || {})
      }
    },
    pageSizeInfoSetter (state, params) {
      state.pageSizeInfo = params || {width: 0, height: 0, ratio: 1}
    },
    setPdfDoc (state, { key, pdfDoc }) {
      if (key && pdfDoc) {
        state.pdfDocDict = { ...state.pdfDocDict, [key]: pdfDoc }
      }
    },
    setPdfUrlLoading (state, { key, action }) {
      if (action === 'add') {
        if (!state.pdfUrlLoading.includes(key)) {
          state.pdfUrlLoading = [...state.pdfUrlLoading, key]
        }
      } else if (action === 'remove') {
        state.pdfUrlLoading = state.pdfUrlLoading.filter(v => v !== key)
      }
    },
    clearAllPdfDocs (state) {
      state.pdfDocDict = {}
      state.pdfUrlLoading = []
    }
  },
  actions: {
    bookInfoGetter ({ state, dispatch, commit }, {bookId}) {
      bookId = bookId || state.bookId || localStorage.getItem('bookId') || ''
      if (!bookId) return Promise.reject()
      commit('bookIdSetter', bookId)
      commit('bookInfoSetter', {})
      return api.getBookInfo({
        bookId: bookId
      }).then(res => {
        if (res.code === 0) {
          let data = res.data || {}
          data.bookAudio = jstools.jsonParse(data.bookAudio)
          commit('bookInfoSetter', data)
          dispatch('fileUrlGetter', {fileNames: [
            data.audioKey,
            data.videoKey,
            data.pdfKey
          ]})
        }
      }).catch(err => {
        console.log(err)
      })
    },
    bookDubInfoGetter ({ state, commit }, {bookId}) {
      bookId = bookId || state.bookId || localStorage.getItem('bookId') || ''
      if (!bookId) return Promise.reject()
      commit('bookIdSetter', bookId)
      commit('bookDubInfoSetter', {})
      return api.getBookDubInfo({
        bookId: bookId
      }).then(res => {
        if (res.code === 0) {
          let data = res.data || {}
          data.parsedData = jstools.jsonParse(data.parsedData)
          commit('bookDubInfoSetter', data)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    myWorksGetter ({ state, commit, dispatch }, {bookId}) {
      bookId = bookId || state.bookId || localStorage.getItem('bookId') || ''
      if (!bookId) return Promise.reject()
      commit('myWorksSetter', [])
      return api.getMyWork({
        bookId: bookId
      }).then(res => {
        if (res.code === 0) {
          let data = res.data || []
          let fileNames = []
          data = data.map(v => {
            fileNames.push(v.dubFileKey)
            fileNames.push(v.fileKey)
            let _reportData = jstools.jsonParse(v.reportData, [])
            let _total = 0
            let _length = _reportData.length
            _reportData = _reportData.filter(v => v)
            _reportData.forEach(v => {_total += v.total_score})
            _total = Math.floor(_total / _length || 0)
            return {...v, total: _total}
          })
          commit('myWorksSetter', data)
          dispatch('fileUrlGetter', {fileNames})
        }
      }).catch(err => {
        console.log(err)
      })
    },
    submitQuestion (store, answer) {
      if (!answer) return Promise.reject()
      return api.submitQuestion(answer).then(res => {
        if (res.code !== 0) {
          console.log(res)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    updateBookProgress ({state}, module) {
      if (!module) return Promise.reject()
      return api.updateBookProgress({
        bookId: state.bookId,
        goodsId: state.goodsId,
        module
      }).then(res => {
        if (res.code !== 0) {
          console.log(res)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    likeWork ({ state, commit }, params = {}) {
      let {status, workId} = params || {}
      if ([status, workId].includes(undefined)) return Promise.reject()
      return api.likeWork(params).then(res => {
        if (res.code === 0) {
          let likeWorkIds = [...state.likeWorkIds]
          if (status) {
            likeWorkIds.push(workId)
          } else {
            likeWorkIds = likeWorkIds.filter(v => v !== workId)
          }
          commit('likeWorkIdsSetter', likeWorkIds)
        } else {
          console.log(res)
        }
        return res
      }).catch(err => {
        console.log(err)
      })
    },
    questionsGetter ({ state, commit, dispatch }, {bookId}) {
      bookId = bookId || state.bookId || localStorage.getItem('bookId') || ''
      if (!bookId) return Promise.reject()
      commit('bookIdSetter', bookId)
      commit('questionsSetter', [])
      commit('questionReplaceDictSetter', {})
      return api.getBookQuestions({
        bookId: bookId
      }).then(res => {
        if (res.code === 0) {
          let data = res.data || []
          let questions = []
          let fileNames = []
          data.forEach(v => {
            let component = ''
            let icon = ''
            let hasProgressbar = false
            let myquestions = v.questions || []
            let defaultValue = [[], [], {}]
            let questionType = 0
            if (v.type === 'words' && v.subType === 'Listen and repeat') {
              component = 'cmp-exercise-listen'
              icon = 'iconfont icon-earphone-1'
              defaultValue = ['', '', {}]
              questionType = 1
              // hasProgressbar = true
            } else if (v.type === 'words' && v.subType === 'Match') {
              component = 'cmp-exercise-connect'
              icon = 'iconfont icon-path'
              defaultValue = [[], [], {}]
              questionType = 2
            } else if (v.type === 'words' && v.subType === 'Listen and choose') {
              component = 'cmp-exercise-choose'
              icon = 'iconfont icon-checked'
              defaultValue = [[], [], {}]
              questionType = 3
              // hasProgressbar = true
            } else if (v.type === 'words' && v.subType === 'Look and choose') {
              component = 'cmp-exercise-choose-3'
              icon = 'iconfont icon-checked'
              defaultValue = [[], [], {}]
              questionType = 3
              // hasProgressbar = true
            } else if (v.type === 'sentences' && v.subType === 'Click and say') {
              component = 'cmp-exercise-read'
              icon = 'iconfont icon-audio'
              defaultValue = ['', '', {}]
              questionType = 4
            } else if (v.type === 'sentences' && v.subType === 'Listen and choose') {
              component = 'cmp-exercise-choose-3'
              icon = 'iconfont icon-checked'
              defaultValue = [[], [], {}]
              questionType = 5
              // hasProgressbar = true
            }
            myquestions = myquestions.map(item => {
              let _item = {...item}
              _item.correctAnswer = defaultValue[0] ? jstools.jsonParse(item.correctAnswer, defaultValue[0]) : (item.correctAnswer || '')
              _item.userAnswer = defaultValue[1] ? jstools.jsonParse(item.userAnswer, defaultValue[1]) : (item.userAnswer || '')
              _item.questionJson = jstools.jsonParse(item.questionJson, defaultValue[2])
              fileNames.push((_item.questionJson.stem || {}).audio || '')
              if (questionType === 1 && _item.userAnswer) {
                if (/^blob:/.test(_item.userAnswer)) {
                  _item.userAnswer = ''
                } else {
                  fileNames.push(_item.userAnswer)
                }
              }
              if (questionType === 3) {_item.doneStatus = !!((_item.userAnswer || [])[0] || {}).image}
              else if ([1, 4].includes(questionType)) {_item.doneStatus = !!_item.userAnswer}
              else if ([2, 5].includes(questionType)) {_item.doneStatus = (_item.userAnswer.length > 0 && _item.userAnswer.length === _item.correctAnswer.length) }
              return _item
            })
            let doneStatusArr = myquestions.map(v => v.doneStatus)
            questions.push({...v, component, icon, myquestions, hasProgressbar, doneStatusArr})
          })
          commit('questionsSetter', questions)
          dispatch('fileUrlGetter', {fileNames})
        }
      }).catch(err => {
        console.log(err)
      })
    },
    shuffleQuestion ({ state, commit }, {ids, _ids}) {
      if (!ids || ids.length === 0) return Promise.resolve()
      return api.shuffleQuestion({ids}).then(res => {
        if (res.code === 0) {
          let result = {}
          let _data = res.data || []
          _data.forEach((v, i) => {
            let _id = _ids[i] || ids[i]
            let data = {...v}
            let defaultValue = [[], [], {}]
            data.correctAnswer = defaultValue[0] ? jstools.jsonParse(v.correctAnswer, defaultValue[0]) : (v.correctAnswer || '')
            data.userAnswer = defaultValue[1] ? jstools.jsonParse(v.userAnswer, defaultValue[1]) : (v.userAnswer || '')
            data.questionJson = jstools.jsonParse(v.questionJson, defaultValue[2])
            data.doneStatus = (data.userAnswer.length > 0 && data.userAnswer.length === data.correctAnswer.length)
            data._id = _id
            result[_id] = data
          })
          commit('questionReplaceDictSetter', {...state.questionReplaceDict, ...result})
        } else {
          Message.error(res.msg || '重新乱序小题失败')
        }
      }).catch(err => {
        Message.error(err.msg || '重新乱序小题失败')
      })
    },
    fileUrlGetter ({ state, commit }, {fileNames}) {
      fileNames = fileNames || []
      fileNames = fileNames.filter(v => (v && !fileNamesLoading.includes(v) && !state.fileUrlDict[v]))
      let httpArr = fileNames.filter(v => /^http/.test(v))
      if (httpArr.length) {
        fileNames = fileNames.filter(v => !(/^http/.test(v)))
        let dict = {}
        httpArr.forEach(v => {
          dict[v] = v
        })
        commit('fileUrlDictSetter', dict)
      }
      if (fileNames.length === 0) return Promise.resolve()
      fileNamesLoading = [...fileNamesLoading, ...fileNames]
      return api.postBatchFileUrl({
        expiration: 86400000,
        fileNames: fileNames
      }).then(res => {
        if (res.code === 0) {
          let data = res.data || []
          if (!data || !(data instanceof Array)) return
          let result = {}
          data.forEach((v, i) => {
            result[fileNames[i]] = v
          })
          commit('fileUrlDictSetter', result)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        fileNamesLoading = fileNamesLoading.filter(v => !fileNames.includes(v))
      })
    },
    loadPdfDocument ({ state, commit }, { fileKey, fileUrl }) {
      return new Promise((resolve, reject) => {
        if (!fileKey || !fileUrl) {
          reject(new Error('fileKey和fileUrl不能为空'));
          return;
        }

        // 如果PDF已经加载，直接返回
        if (state.pdfDocDict[fileKey]) {
          resolve(state.pdfDocDict[fileKey]);
          return;
        }

        // 如果PDF正在加载，等待加载完成
        if (state.pdfUrlLoading.includes(fileKey)) {
          const checkLoading = setInterval(() => {
            if (!state.pdfUrlLoading.includes(fileKey)) {
              clearInterval(checkLoading);
              if (state.pdfDocDict[fileKey]) {
                resolve(state.pdfDocDict[fileKey]);
              } else {
                reject(new Error('PDF加载失败'));
              }
            }
          }, 100);
          return;
        }

        // 开始加载PDF
        commit('setPdfUrlLoading', { key: fileKey, action: 'add' });

        pdfjsLib.getDocument(fileUrl).promise
          .then((pdf) => {
            commit('setPdfDoc', { key: fileKey, pdfDoc: pdf });
            commit('setPdfUrlLoading', { key: fileKey, action: 'remove' });
            resolve(pdf);
          })
          .catch((error) => {
            commit('setPdfUrlLoading', { key: fileKey, action: 'remove' });
            console.error('PDF加载失败:', error);
            reject(error);
          });
      });
    },
    clearPdfDoc ({ state }, { fileKey }) {
      if (fileKey && state.pdfDocDict[fileKey]) {
        try {
          state.pdfDocDict[fileKey].destroy();
        } catch (error) {
          console.error('清理PDF文档失败:', error);
        }
        const newDict = { ...state.pdfDocDict };
        delete newDict[fileKey];
        state.pdfDocDict = newDict;
      }
    },
    clearAllPdfDocAction ({ state, commit }) {
      Object.keys(state.pdfDocDict).forEach(key => {
        try {
          state.pdfDocDict[key].destroy();
        } catch (error) {
          console.error('清理PDF文档失败:', error);
        }
      });
      commit('clearAllPdfDocs');
    },
  },
  modules: {
  }
})
